/**
 * Decide whether a debounced search term should be committed up to the parent.
 *
 * Commit only when the user's debounced input actually CHANGED (compared to the
 * PREVIOUS debounced value) — not merely when it differs from the incoming
 * `value`. The bug: an external reset (Clear all / back-navigation) sets
 * `value` to "" while the debounced term is momentarily still the old text, so a
 * `debounced !== value` test re-commits that stale text and overwrites the reset.
 * Comparing against the previous debounced value ignores that transient. The
 * extra `!== committedValue` guard avoids echoing an externally-set value back.
 */
export function shouldCommitSearch(
  debounced: string,
  prevDebounced: string,
  committedValue: string,
): boolean {
  if (debounced === prevDebounced) return false;
  return debounced !== committedValue;
}
